import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Screens from '..';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import rewardCenterMiddleware from '../RewardCenter/utils/middleware';
import NotificationContext from '../../context/NotificationContext';
var VipAccessFlow = /*#__PURE__*/function (_Component) {
  function VipAccessFlow() {
    var _this;
    _classCallCheck(this, VipAccessFlow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VipAccessFlow, [].concat(args));
    _this.purchaseVipAccessHandler = function () {
      Logger.setActionTrigger('vipAccessPopup');
      _this.props.dismissModal();
      QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.Shop), routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.VIP));
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this.props.coin.toString(),
        type: 'vip',
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };
    _this.redeemVipAccessHandler = function () {
      _this.props.dismissModal();
      rewardCenterMiddleware(_objectSpread(_objectSpread({}, _this.props), {}, {
        notificationContext: _this.context
      }));
    };
    _this.playNowHandler = function () {
      _this.props.dismissModal();
      QueryParamsProxy.navigate(_this.props.navigation, Screens.VIP);
      QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_NAVIGATE_TO, undefined));
    };
    return _this;
  }
  _inherits(VipAccessFlow, _Component);
  return _createClass(VipAccessFlow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isVipRoomUnlocked = _this$props.isVipRoomUnlocked,
        enterRequirements = _this$props.enterRequirements,
        copys = _this$props.copys;
      return this.props.render({
        purchaseVipAccess: this.purchaseVipAccessHandler,
        redeemVipAccess: this.redeemVipAccessHandler,
        playNow: this.playNowHandler,
        enterRequirements: enterRequirements,
        isVipRoomUnlocked: isVipRoomUnlocked,
        copys: copys
      });
    }
  }]);
}(Component);
VipAccessFlow.contextType = NotificationContext;
export { VipAccessFlow as default };